export enum CheckboxTestIds {
  "CHECKBOX_CHECKED_INDICATOR" = "CHECKBOX_CHECKED_INDICATOR",
}
